export default __webpack_public_path__ + "dad49ae74a663721c9ce9c29b8367720.jpg";